import { NskHead } from "~/components/common/head/NskHead";
import { VendorLayoutV2 } from "~/components/common/layouts/VendorLayoutV2";
import { Page as Component } from "~/components/specifics/vendors/messages/Page";

export const PATH = "/vendors/messages";

function Home() {
	return (
		<>
			<NskHead title="チャット" />
			<VendorLayoutV2>
				<Component />
			</VendorLayoutV2>
		</>
	);
}

export default Home;
